import { Component, OnInit } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import * as $ from 'jquery';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
  title = 'collexusdebtorportal';

  public loadCustomStyle: boolean = false;
  public customStyleUrl: any = null;

  constructor(private sanitizer: DomSanitizer) {
    // Commented out for now, but this will allow loading of different style sheets
    /*if (new Date().getSeconds() % 2 === 0) {
      this.customStyleUrl = this.sanitizer.bypassSecurityTrustResourceUrl('assets\\styles1.css');
      this.loadCustomStyle = true;
    }*/
  }

  ngOnInit(): void {
    // Included for mobile menu used in styling guide
    $("#collexus-mobile-menu").click(function() {
      $('.menu').toggleClass('menu-open');
    });

    $("#mobile-menu").click(function() {
      $('.menu').toggleClass('menu-open');
    });
  
    $("#mobile-menu-close").click(function() {
      $('.menu').toggleClass('menu-open');
    });

    $("#mobile-nav-link-dashboard").click(function() {
      $('.menu').toggleClass('menu-open');
    });

    $("#mobile-nav-link-contact").click(function() {
      $('.menu').toggleClass('menu-open');
    });

    $("#mobile-nav-link-login").click(function() {
      $('.menu').toggleClass('menu-open');
    });

    $("#mobile-nav-link-logout").click(function() {
      $('.menu').toggleClass('menu-open');
    });
  }
}
